import React from 'react';

export interface TabItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  badge?: string | number;
  disabled?: boolean;
}

export interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (tabId: string) => void;
  variant?: 'line' | 'pills';
  fullWidth?: boolean;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onChange,
  variant = 'line',
  fullWidth = false,
  className = '',
}) => {
  return (
    <div className={`w-full overflow-x-auto no-scrollbar border-b border-[#E5E9E9] ${className}`}>
      <nav className={`flex items-center gap-1 ${fullWidth ? 'w-full' : 'w-max'}`} role="tablist">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              disabled={tab.disabled}
              onClick={() => !tab.disabled && onChange(tab.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-xs sm:text-sm font-bold transition-all duration-150 cursor-pointer select-none whitespace-nowrap outline-none focus-visible:ring-2 focus-visible:ring-[#1fb4ac] disabled:opacity-40 disabled:cursor-not-allowed ${
                fullWidth ? 'flex-1 justify-center' : ''
              } ${
                variant === 'line'
                  ? isActive
                    ? 'text-[#1fb4ac] border-b-2 border-[#1fb4ac]'
                    : 'text-[#5F6368] hover:text-[#111111] border-b-2 border-transparent'
                  : isActive
                  ? 'bg-[#E8FAF9] text-[#1b8e88] rounded-xl border border-[#56E8E1]/40'
                  : 'text-[#5F6368] hover:text-[#111111] hover:bg-[#F7FAFA] rounded-xl border border-transparent'
              }`}
            >
              {tab.icon && <span className="shrink-0">{tab.icon}</span>}
              <span>{tab.label}</span>
              {tab.badge !== undefined && (
                <span
                  className={`px-1.5 py-0.5 text-[10px] font-extrabold rounded-full ${
                    isActive ? 'bg-[#1fb4ac] text-white' : 'bg-[#E5E9E9] text-[#5F6368]'
                  }`}
                >
                  {tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
